import { Box, Button, Modal, Stack, Typography } from '@mui/material'
import { Dispatch, SetStateAction } from 'react'
import XMarkWhiteSvg from '~/@ui/_sharedSvgs/FontAwesome/XMarkWhite.svg?react'
import ArrowLeftNewSvg from '~/@ui/_sharedSvgs/ui/ArrowLeftNew.svg?react'

type Props = {
  isOpen: boolean
  handleClose: () => void
  title: string
  text: string
  faqQuestions: { title: string; text: string }[]
  setModal: Dispatch<
    SetStateAction<{ isOpen: boolean; title: string; text: string }>
  >
}

export const FaqModal = ({
  isOpen,
  handleClose,
  title,
  text,
  faqQuestions,
  setModal,
}: Props) => {
  const currentIndex = faqQuestions.findIndex((item) => item.title === title)

  const isFirst = currentIndex === 0
  const isLast = currentIndex === faqQuestions.length - 1

  const handlePrev = () => {
    if (!isFirst && currentIndex > 0) {
      const prevQuestion = faqQuestions[currentIndex - 1]
      setModal({
        isOpen: true,
        title: prevQuestion.title,
        text: prevQuestion.text,
      })
    }
  }

  const handleNext = () => {
    if (!isLast && currentIndex < faqQuestions.length - 1) {
      const nextQuestion = faqQuestions[currentIndex + 1]
      setModal({
        isOpen: true,
        title: nextQuestion.title,
        text: nextQuestion.text,
      })
    }
  }

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Stack className="w-screen h-dvh justify-between pt-4 pb-16 bg-zBlack200 overflow-auto">
        <Stack className="w-full max-w-[768px] self-center gap-8">
          <Button
            className="w-16 h-11 self-end mx-6 bg-zBlack300"
            onClick={handleClose}>
            <XMarkWhiteSvg />
          </Button>

          <Stack className="gap-3 px-6">
            <Typography className="text-xl font-bold text-zWhite200">
              {title}
            </Typography>
            <Typography className="text-3d font-medium text-zWhite200">
              {text}
            </Typography>
          </Stack>
        </Stack>

        <Stack className="flex-row w-full max-w-[768px] justify-between self-center items-center px-6">
          <Button
            variant="contained"
            className="w-16 h-11 bg-zWhite200 text-zBlack200"
            disabled={isFirst}
            onClick={handlePrev}>
            <ArrowLeftNewSvg />
          </Button>

          <Stack className="flex-row gap-1">
            {faqQuestions.map((item) => (
              <Box
                key={item.title}
                className="w-[11px] h-[10px] rounded"
                sx={(theme) => ({
                  bgcolor:
                    item.title === title
                      ? theme.palette.custom.zWhite200
                      : theme.palette.custom.zBlack300,
                })}
              />
            ))}
          </Stack>

          <Button
            variant="contained"
            className="w-16 h-11 bg-zWhite200 text-zBlack200"
            disabled={isLast}
            onClick={handleNext}>
            <ArrowLeftNewSvg className="rotate-180" />
          </Button>
        </Stack>
      </Stack>
    </Modal>
  )
}
